import { RuleSet } from '../../query-builder/interfaces/rule';
import { Pagination } from '../../shared/pagination/pagination';
import { PaginationOptions } from '../../shared/pagination/pagination-options';
import { PaginationSort } from '../../shared/pagination/pagination-sort';

export interface Query {
  distinct?: boolean;
  select: any[];
  where?: RuleSet;
}

export interface Column {
  label: string;
  field: string;
  width: number;
  sortable?: string;
  selection?: boolean;
  type?: string;
}

export class PaginationQuery<T> extends Pagination<T> {
  constructor(
    public readonly items: T[],
    public readonly itemCount: number,
    public readonly totalItems: number,
    public readonly pageCount: number,
    public readonly options: PaginationOptions,
    public readonly columns: Column[],
    public readonly ids?: number[],
    public readonly sort?: PaginationSort,
  ) {
    super(items, itemCount, totalItems, pageCount, options, ids);
  }

  public static empty<T>(options: PaginationOptions = new PaginationOptions(1, 25)): PaginationQuery<T> {
    return new PaginationQuery([], 0, 0, 1, options, []);
  }

  public static fromJson<T>(json: any): PaginationQuery<T> {
    const [column, direction]: [string, string] = Object.entries<string>(json.sort || { '': 'DESC' })[0];
    return new PaginationQuery<T>(
      json.items,
      json.itemCount,
      json.totalItems,
      json.pageCount,
      PaginationOptions.fromJson(json.options),
      json.columns,
      json.ids,
      { column, direction: direction.toLowerCase() as PaginationSort['direction'] },
    );
  }
}
